import 'swiper/css';
import 'swiper/css/scrollbar';

import { Scrollbar } from 'swiper';
import Image from 'next/future/image';
import React, { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { IProduct } from '@/models';

interface Props {
  product: IProduct;
}

const ShoeCharacteristics: React.FC<Props> = ({ product }) => {
  const characteristics = useMemo(
    () => [
      {
        title: 'Temperature Regulating',
        image: '/v2/product/shoe-characteristics/temperature-regulating.svg'
      },
      {
        title: 'Antibacteria',
        image: '/v2/product/shoe-characteristics/anti-bacteria.svg'
      },
      {
        title: 'Eco-Friendly',
        image: '/v2/product/shoe-characteristics/eco-friendly.svg'
      },
      {
        title: 'No smell',
        image: '/v2/product/shoe-characteristics/no-smell.svg'
      },
      {
        title: 'No sweat',
        image: '/v2/product/shoe-characteristics/no-sweat.svg'
      },
      {
        title: 'Breathable',
        image: '/v2/product/shoe-characteristics/breathable.svg'
      }
    ],
    []
  );

  if (!product.slug.includes('shoe') && !product.slug.includes('scarp')) {
    return null;
  }

  return (
    <section className="section">
      <Swiper
        wrapperTag="ul"
        slidesPerView={3}
        spaceBetween={16}
        modules={[Scrollbar]}
        scrollbar={{ hide: false }}
        className="swiperScrollbar"
        breakpoints={{
          768: {
            slidesPerView: 5
          },
          1024: {
            slidesPerView: 6
          }
        }}
      >
        {characteristics.map((characteristic, idx) => (
          <SwiperSlide
            key={idx}
            tag="li"
            className="flex flex-col justify-center items-center text-center space-y-6"
          >
            <Image
              src={characteristic.image}
              alt={characteristic.title}
              width={0}
              height={0}
              sizes="100vw"
              className="w-12 h-auto md:w-14 xl:w-16"
            />

            <p className="h6">{characteristic.title}</p>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ShoeCharacteristics;
